<div class="modal-body">
  <div class="modal-title mb-3">Remove from Guide?</div>
  <p class="mb-4">This will also remove {{suggestionNumber}} suggestion(s) from your guide.</p>
  <div class="footer-button">
    <button matRipple (click)="removeSection()" class="custom-button destructive-button">Remove</button>
    <button matRipple (click)="close()" class="custom-button preferred-button ml-2">Cancel</button>
  </div>
</div>
